import { render, staticRenderFns } from "./BlackDetailMg.vue?vue&type=template&id=3ee4a504&scoped=true"
import script from "./BlackDetailMg.vue?vue&type=script&lang=js"
export * from "./BlackDetailMg.vue?vue&type=script&lang=js"
import style0 from "./BlackDetailMg.vue?vue&type=style&index=0&id=3ee4a504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee4a504",
  null
  
)

export default component.exports